import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsConverterService, defaultFSCatalog } from '../../../services/cms-converter/cms-converter.service'
import { ConvertedComponentData, FsCatalog } from '../../types'
import { LocationsMapLocationData } from './locations-map-location/locations-map-location.component.converter'

@Injectable({ providedIn: 'root' })
export class LocationsMapRegionConverter extends CmsConverterService<LocationsMapRegionData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      region: formData?.st_region?.value?.identifier ?? '',
      locations: formData?.st_locations ?? defaultFSCatalog
    }
  }
}

export const LOCATIONS_MAP_REGION_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, LocationsMapRegionData>>('LocationsMapRegionConverter')

export interface LocationsMapRegionData extends ConvertedComponentData {
  region: string;
  locations: FsCatalog<LocationsMapLocationData>;
}
